import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class GetLodgingProductInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 9;
        const total_levels = 6;
        const level1 = 6;
        const level2 = 5;
        const level2_prefix = level1 - level2;
        const level3 = 4;
        const level3_prefix = level1 - level3;
        const level4 = 3;
        const level4_prefix = level1 - level4;
        const level5 = 2;
        const level6 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                {/*<h3 className="mb0 mt40">9. 여행상품 삭제 API </h3>*/}
                <h3 className="mb0 mt40">숙박 상품 보기</h3>
                <div className="blog-post-meta">
                    <span className="s-post">숙박 상품 정보 보기</span>
                    <h3 className="request-method">
                        <span className="label label-success">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/lodgings/{'{travelProductId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>AccommodationDTO</td>
                            <td></td>
                        </tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>travelProductId</td><td>Long</td><td>여행상품 아이디</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerProductId</td><td>String</td><td>셀러에서 상품을 관리하기 위해 사용한 유닉 아이디</td></tr>
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>vendorId</td><td>String</td><td>vendor Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>productId</td><td>Long</td><td>프로덕트 아이디</td></tr>
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerCategoryId</td><td>Integer</td><td>seller Category Id</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerCategoryName</td><td>String</td><td>seller Category Name</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>productDetailType</td><td>String</td>
                            <td>여행 세부 분류
                                <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>HOTEL</td><td>호텔</td></tr>
                                <tr><td>RESORT</td><td>리조트</td></tr>
                                <tr><td>PENSION</td><td>펜션</td></tr>
                                <tr><td>GUEST_HOUSE</td><td>게스트하우스</td></tr>
                                <tr><td>CAMPING</td><td>캠핑</td></tr>
                                <tr><td>MOTEL</td><td>모텔</td></tr>
                                </tbody>
                            </table>
                            </td></tr>


                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>vendorItemPackageId</td><td>Long</td><td>vendor Item Package Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>travelType</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    여행 분류
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>DOMESTIC</td><td>국내여행</td></tr>
                                    <tr><td>OVERSEAS</td><td>해외여행</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>qcStatus</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>SAVED_TEMPORARY</td><td>임시 저장</td></tr>
                                    <tr><td>WAITING_APPROVAL_MD</td><td>MD 승인 대기</td></tr>
                                    <tr><td>WAITING_APPROVAL_QC</td><td>QC 승인 대기</td></tr>
                                    <tr><td>COMPLETE_APPROVAL</td><td>승인 완료</td></tr>
                                    <tr><td>REJECTED</td><td>승인 반려</td></tr>
                                    <tr><td>BLOCKED</td><td>막힌</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>saleStatus</td><td>String</td>
                            <td>판매 상태
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>BEFORE_SALE</td><td>판매전</td></tr>
                                    <tr><td>ON_SALE</td><td>판매중</td></tr>
                                    <tr><td>SUSPENDED</td><td>정지</td></tr>
                                    <tr><td>ABORTED</td><td>중단</td></tr>
                                    <tr><td>CLOSED</td><td>마감</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>name</td><td>String</td><td>여행상품명</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>introduction</td><td>String</td><td>숙박시설 소개 </td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>notice</td><td>String</td><td>숙박시설 공지사항</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>benefits</td><td>ArrayList</td><td>숙박시설 특별혜택</td></tr>
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>displayCategoryCode</td><td>Long</td><td>display Category Code</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>displayKeyword</td><td>String</td><td>상품에 표시할 지역 키워드</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>searchTags</td><td>ArrayList</td><td>서치태그 리스트</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>images</td><td>ArrayList</td><td>이미지</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>path</td><td>String</td><td>path</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrl</td><td>String</td><td>셀러 이미지 URL</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrlMethod</td><td>String</td><td>Http method</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>representative</td><td>boolean</td><td>이미지가 상품 대표함, 상품당 단일 대표이미지 보유.</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerImageCategory</td><td>String</td><td>sellerImageCategory</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>imageGroup</td><td>String</td>
                            <td>이미지 설명
                                <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>VIEW</td><td>내외관/전경</td></tr>
                                <tr><td>FACILITY</td><td>부대시설</td></tr>
                                <tr><td>RESTAURANT</td><td>식당</td></tr>
                                <tr><td>ETC</td><td>기타</td></tr>
                                <tr><td>ROOM</td><td>객실</td></tr>
                                <tr><td>BASIC</td><td>기본</td></tr>
                                </tbody>
                            </table>
                            </td></tr>

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>resizedImages</td><td>List{'<ResizedImage>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>type</td><td>ResizeImageType</td><td>type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>path</td><td>String</td><td>path</td></tr>*/}

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>String</td><td>이미지 설명</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>seq</td><td>int</td><td>seq</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerPropertyCategory</td><td>String</td><td>sellerPropertyCategory</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>areaId</td><td>String</td><td>areaId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerBrandId</td><td>Long</td><td>sellerBrandId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>brandCode</td><td>String</td><td>brandCode</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>brandName</td><td>String</td><td>brandName</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerChainId</td><td>Long</td><td>sellerChainId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>chainCode</td><td>String</td><td>chainCode</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>chainName</td><td>String</td><td>chainName</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>airportCode</td><td>String</td><td>airportCode</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>cityCode</td><td>String</td><td>cityCode</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>registryNumber</td><td>String</td><td>registryNumber</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>multiUnit</td><td>Boolean</td><td>multiUnit</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>buildDate</td><td>LocalDate</td><td>build Date</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>renovationDate</td><td>LocalDate</td><td>renovation Date</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>propertyCode</td><td>String</td><td>The code that uniquely identifies a single hotel property. The hotel code is decided between vendors.</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>ttiCode</td><td>String</td><td>https://www.tti.org/resources/tti-codes/</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>childrenAllowed</td><td>Boolean</td><td>childrenAllowed</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>petsAllowed</td><td>Boolean</td><td>petsAllowed</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>breakfastServed</td><td>Boolean</td><td>breakfastServed</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerTaxId</td><td>String</td><td>sellerTaxId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>allRatePlanInclusive</td><td>Boolean</td><td>Indicates if all rate plans at the property provide all-inclusive amenities.</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>someRatePlanInclusive</td><td>Boolean</td><td>Indicates if some, but not all, rate plans at the property provide all-inclusive amenities</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>allInclusiveDetail</td><td>TravelDescription</td><td>Details about amenities and services included in the all-inclusive rates</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>title</td><td>String</td><td>title</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>type</td><td>String</td><td>type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>content</td><td>String</td><td>content</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>format</td><td>ContentFormat</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>TEXT</td><td>TEXT</td></tr>*/}
                        {/*        <tr><td>HTML</td><td>HTML</td></tr>*/}
                        {/*        <tr><td>JSON</td><td>JSON</td></tr>*/}
                        {/*        <tr><td>IMAGE</td><td>IMAGE</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>minLOS</td><td>int</td><td>minLOS</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>maxLOS</td><td>int</td><td>maxLOS</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>roomQuantity</td><td>int</td><td>room Quantity</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>totalFloors</td><td>int</td><td>total Floors</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>rating</td><td>Rating</td><td>rating</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>refundByBusinessDay</td><td>Boolean</td><td>근무일에 환불</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelType</td><td>Object</td><td>
                            취소 환불 정책
                            <table className="table table-striped">
                            <tbody>
                            <tr><th>Optional Value</th><th>Description</th></tr>
                            <tr><td>AUTO</td><td>자동취소</td></tr>
                            <tr><td>APPROVAL</td><td>승인취소</td></tr>
                            </tbody>
                        </table></td></tr>


                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>cancelPeriodType</td><td>CancelPeriodType</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>BEFORE_USE</td><td>BEFORE_USE</td></tr>*/}
                        {/*        <tr><td>AFTER_7DAYS</td><td>AFTER_7DAYS</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}

                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelPolicyNotice</td><td>String</td><td>취소 환불 유의사항</td></tr>

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>sellerInstanceBooking</td><td>Boolean</td><td>seller Instance Booking</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>instantBooking</td><td>Boolean</td><td>실시간 예약 가능 여부 </td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>additionalInfoPrompt</td><td>String</td><td>주문 추가정보</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>usageGuide</td><td>String</td><td>이용 안내</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>usageNotice</td><td>String</td><td>유의사항 기재</td></tr>
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>legalTerms</td><td>String</td><td>legal Terms</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>descriptions</td><td>List{'<TravelDescription>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>title</td><td>String</td><td>title</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>type</td><td>String</td><td>type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>content</td><td>String</td><td>content</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>format</td><td>ContentFormat</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>TEXT</td><td>TEXT</td></tr>*/}
                        {/*        <tr><td>HTML</td><td>HTML</td></tr>*/}
                        {/*        <tr><td>JSON</td><td>JSON</td></tr>*/}
                        {/*        <tr><td>IMAGE</td><td>IMAGE</td></tr>*/}
                        {/*        <tr><td>URL</td><td>URL</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>path</td><td>String</td><td>path</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrl</td><td>String</td><td>sellerUrl</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrlMethod</td><td>UrlMethod</td><td>sellerUrlMethod</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>seq</td><td>int</td><td>seq</td></tr>*/}


                        <tr><td>&nbsp;</td><td colSpan={level2}>locations</td><td>ArrayList</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>latitude</td><td>Double</td><td>위도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>longitude</td><td>Double</td><td>경도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roadNameAddress</td><td>String</td><td>도로명 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>landNumberAddress</td><td>String</td><td>지번 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>nation</td><td>String</td><td>국가</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>province</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>city</td><td>String</td><td>시</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>district</td><td>String</td><td>구</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>town</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>zipCode</td><td>String</td><td>우편번호</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>reservationNotifications</td><td>ArrayList</td><td>예약/취소 알림</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>type</td><td>String</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>PHONE</td><td>전화</td></tr>
                                <tr><td>FAX</td><td>팩스</td></tr>
                                <tr><td>EMAIL</td><td>이메일</td></tr>
                                </tbody>
                            </table></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactInfo</td><td>String</td><td>연락처 정보</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactDescription</td><td>String</td><td>설명</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>contacts</td><td>ArrayList</td><td>연락처</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactType</td><td>String</td>
                            <td>연락처 유형
                                <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>PHONE</td><td>전화</td></tr>
                                <tr><td>FAX</td><td>팩스</td></tr>
                                <tr><td>EMAIL</td><td>이메일</td></tr>
                                <tr><td>WEBSITE</td><td>웹사이트</td></tr>
                                </tbody>
                            </table></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactUseType</td><td>String</td>
                            <td> <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>REPRESENTATIVE</td><td>대표연락처</td></tr>
                                <tr><td>BOOKING_INQUIRY</td><td>예약문의 연락처</td></tr>
                                <tr><td>CANCEL_INQUIRY</td><td>취소문의 연락처</td></tr>
                                <tr><td>EMERGENCY</td><td>긴급연락망</td></tr>
                                </tbody>
                            </table></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contact</td><td>String</td><td>연락처</td></tr>

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>review</td><td>Review</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>count</td><td>long</td><td>count</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>good</td><td>long</td><td>good</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>poor</td><td>long</td><td>poor</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>score</td><td>double</td><td>score</td></tr>*/}

                        <tr><td>&nbsp;</td><td colSpan={level2}>trafficInfo</td><td>String</td><td>찾아가는 길 설명하는 자유텍스트 입력</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>publicTransportInfo</td><td>String</td><td>주변 대중교통 정보 설명하는 자유 텍스트 입력</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>nearbyLandmarks</td><td>ArrayList</td><td>주변 관광지 정보</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>latitude</td><td>Double</td><td>위도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>longitude</td><td>Double</td><td>위도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>distance</td><td>Integer</td><td>거리</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>distanceUnit</td><td>String</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>KILOMETER</td><td>킬로미터</td></tr>
                                <tr><td>METER</td><td>미터</td></tr>
                                </tbody>
                            </table></td></tr>

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>direction</td><td>Direction</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>EAST</td><td>EAST</td></tr>*/}
                        {/*        <tr><td>WEST</td><td>WEST</td></tr>*/}
                        {/*        <tr><td>NORTH</td><td>NORTH</td></tr>*/}
                        {/*        <tr><td>SOUTH</td><td>SOUTH</td></tr>*/}
                        {/*        <tr><td>NORTHEAST</td><td>NORTHEAST</td></tr>*/}
                        {/*        <tr><td>NORTHWEST</td><td>NORTHWEST</td></tr>*/}
                        {/*        <tr><td>SOUTHEAST</td><td>SOUTHEAST</td></tr>*/}
                        {/*        <tr><td>SOUTHWEST</td><td>SOUTHWEST</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>transportations</td><td>List{'<Transportation>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>type</td><td>TransportationType</td><td>Description</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>Description</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>operationPeriods</td><td>List{'<OperationPeriod>'}</td><td>Description</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>startTime</td><td>String</td><td>startTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>endTime</td><td>String</td><td>endTime</td></tr>*/}

                        <tr><td>&nbsp;</td><td colSpan={level2}>amenities</td><td>ArrayList</td><td>객실 공통 구비 품목</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerAmenityId</td><td>String</td><td>seller Amenity Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>id</td><td>String</td><td>amenity id</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>value</td><td>String</td><td>value</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>attributes</td><td>List{'<AccommodationAttribute>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerAttributeId</td><td>String</td><td>sellerAttributeId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>id</td><td>String</td><td>id</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>value</td><td>String</td><td>value</td></tr>*/}

                        <tr><td>&nbsp;</td><td colSpan={level2}>themes</td><td>ArrayList</td><td>테마정보.</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerThemeId</td><td>String</td><td>seller Theme Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>id</td><td>String</td><td>theme id</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>statistics</td><td>List{'<AccommodationStatistics>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerStatisticsId</td><td>Long</td><td>sellerStatisticsId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>value</td><td>String</td><td>value</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>meetingRooms</td><td>List{'<MeetingRoom>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerMeetingRoomId</td><td>String</td><td>sellerMeetingRoomId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>code</td><td>String</td><td>code</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>type</td><td>String</td><td>type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>area</td><td>double</td><td>area</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>level</td><td>int</td><td>level</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>capacity</td><td>int</td><td>capacity</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>String</td><td>description</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>features</td><td>List{'<String>'}</td><td>features</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>restaurants</td><td>List{'<Restaurant>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>vendorRestaurantId</td><td>String</td><td>vendorRestaurantId</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>cuisineType</td><td>String</td><td>cuisineType</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>capacity</td><td>int</td><td>capacity</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>offerBreakfast</td><td>boolean</td><td>offerBreakfast</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>offerBrunch</td><td>boolean</td><td>offerBrunch</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>offerLunch</td><td>boolean</td><td>offerLunch</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>offerDinner</td><td>boolean</td><td>offerDinner</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>reservationNeeded</td><td>boolean</td><td>reservationNeeded</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>String</td><td>description</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>OperationPeriod</td><td>Map{'<FacilityType,OperationPeriod'}></td><td></td></tr>*/}

                        <tr><td>&nbsp;</td><td colSpan={level2}>rooms</td><td>ArrayList</td><td>객실</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>travelItemId</td><td>Long</td><td>여행상품 id</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerItemId</td><td>String</td><td>셀러 여행 아이템 id</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>객실명</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roomType</td><td>String</td><td>room type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roomCategory</td><td>String</td><td>roomCategory</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>saleStatus</td><td>SaleStatus</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>BEFORE_SALE</td><td>BEFORE_SALE</td></tr>*/}
                        {/*        <tr><td>ON_SALE</td><td>ON_SALE</td></tr>*/}
                        {/*        <tr><td>SUSPENDED</td><td>SUSPENDED</td></tr>*/}
                        {/*        <tr><td>ABORTED</td><td>ABORTED</td></tr>*/}
                        {/*        <tr><td>CLOSED</td><td>CLOSED</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>saleStartedAt</td><td>LocalDateTime</td><td>판매노출 시작일</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>saleEndedAt</td><td>LocalDateTime</td><td>판매노출 종료일</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>taxType</td><td>TaxType</td>*/}
                        {/*    <td><table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>TAX</td><td>TAX</td></tr>*/}
                        {/*        <tr><td>FREE</td><td>FREE</td></tr>*/}
                        {/*        <tr><td>ZERO</td><td>ZERO</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>totalCount</td><td>int</td><td>합계</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>area</td><td>Double</td><td>지역</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>floor</td><td>Integer</td><td>층</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roomComponent</td><td>RoomComponent</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>images</td><td>List</td><td>이미지</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>path</td><td>String</td><td>경로</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerUrl</td><td>String</td><td>셀러 이미지 URL</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerUrlMethod</td><td>UrlMethod</td><td>Http method</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>representative</td><td>boolean</td><td>이미지가 상품 대표함, 상품당 단일 대표이미지 보유</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerImageCategory</td><td>String</td><td>sellerImageCategory</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>imageGroup</td><td>String</td>
                            <td>이미지 설명
                                <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>VIEW</td><td>내외관/전경</td></tr>
                                <tr><td>FACILITY</td><td>부대시설</td></tr>
                                <tr><td>RESTAURANT</td><td>식당</td></tr>
                                <tr><td>ETC</td><td>기타</td></tr>
                                <tr><td>ROOM</td><td>객실</td></tr>
                                <tr><td>BASIC</td><td>기본</td></tr>
                                </tbody>
                            </table>
                            </td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>descriptions</td><td>ArrayList</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>title</td><td>String</td><td>타이틀</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>type</td><td>String</td><td>컨텐츠 타입</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>content</td><td>String</td><td>함유량</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>format</td><td>String</td>
                            <td> <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>TEXT</td><td>TEXT</td></tr>
                                <tr><td>HTML</td><td>HTML</td></tr>
                                <tr><td>JSON</td><td>JSON</td></tr>
                                <tr><td>IMAGE</td><td>IMAGE</td></tr>
                                <tr><td>URL</td><td>URL</td></tr>
                                </tbody>
                            </table></td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>amenities</td><td>ArrayList</td><td>	객실 공통 구비 품목</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerAmenityId</td><td>String</td><td>seller Amenity Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>id</td><td>String</td><td>amentity id</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>value</td><td>String</td><td>value</td></tr>*/}

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>bedGroups</td><td>ArrayList</td><td></td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerBedGroupId</td><td>String</td><td>seller Bed Group Id</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>description</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>configurations</td><td>ArrayList</td><td></td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>size</td><td>String</td><td>size</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>type</td><td>String</td><td>type</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>quantity</td><td>Long</td><td>quantity</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>priceCheck</td><td>BedGroupPriceCheck</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>sellerUrl</td><td>String</td><td>sellerUrl</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>sellerUrlMethod</td><td>UrlMethod</td><td>sellerUrlMethod</td></tr>*/}

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>occupancy</td><td>Object</td><td>투숙인원</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>standardOccupancy</td><td>Integer</td><td>기준인원</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>totalMaxAllowed</td><td>Integer</td><td>최대인원</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>adultMaxAllowed</td><td>Integer</td><td>adultMaxAllowed</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>childMaxAllowed</td><td>Integer</td><td>어린이 무료 동반 입실</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>ageCategories</td><td>ArrayList</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>ageType</td><td>String</td><td>연령 유형. ADULT or CHILD.</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>minAge</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 12세 까지 입력 가능)</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>views</td><td>ArrayList</td><td></td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerViewId</td><td>String</td><td>seller View Id</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>id</td><td>String</td><td>id</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>String</td><td>name</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extension</td><td>Map{'<String,String>'} </td><td>extension</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>deleted</td><td>boolean</td><td>삭제됨</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>rates</td><td>ArrayList</td><td>rates</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>rateId</td><td>Long</td><td>rateId</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>travelItemIds</td><td>ArrayList</td><td>여행 아이템 id</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerRateId</td><td>String</td><td>셀러 웹사이트의 요금 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>요금카테고리명</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>saleStartedAt</td><td>LocalDateTime</td><td>투숙 기간 - 시작</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>saleEndedAt</td><td>LocalDateTime</td><td>투숙 기간 - 종료</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>useSellerProvidedPrice</td><td>boolean</td><td>Indicates whether the price info is provided by seller instead of being calculated by Coupang</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>useSellerProvidedFee</td><td>boolean</td><td>Indicates whether the fee info(e.g. cancel fee) is provided by seller instead of being calculated by Coupang</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>valid</td><td>boolean</td><td>유효</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>rateType</td><td>RateCategoryType</td>*/}
                        {/*    <td> <table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>STANDARD</td><td>STANDARD</td></tr>*/}
                        {/*        <tr><td>CUSTOM</td><td>CUSTOM</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>amenities</td><td>List{'<RateAmenity>'}</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerAmenityId</td><td>String</td><td>seller Amenity Id</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>id</td><td>String</td><td>id</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>String</td><td>name</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>value</td><td>String</td><td>value</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>bedGroups</td><td>List{'<BedGroup>'}</td><td>bedGroups</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>mealPolicy</td><td>Object</td><td>조식 정책</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>meals</td><td>ArrayList</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>mealType</td><td>String</td>
                            <td> <table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>BREAKFAST</td><td>조식</td></tr>
                                <tr><td>LUNCH</td><td>점심</td></tr>
                                <tr><td>DINNER</td><td>저녁</td></tr>
                                </tbody>
                            </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>included</td><td>boolean</td><td>포함 여부</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>numberOfGuests</td><td>int</td><td>조식 유형</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>surchargeAvailable</td><td>boolean</td><td>조식 추가 요금</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>sameRoomStandardOccupancy</td><td>boolean</td><td>sameRoomStandardOccupancy</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>mealStyle</td><td>String</td><td>조식 유형</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>surcharges</td><td>ArrayList</td><td>조식 추가 요금 설정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>ageType</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ADULT</td><td>성인</td></tr>
                                    <tr><td>CHILD</td><td>아동</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>minAge</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 12세 까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>surcharge</td><td>double</td><td>조식 요금 입력 ('현장결제' 기준으로 요금을 설정해주세요.)</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>기술</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>cancelPolicy</td><td>Object</td><td>취소 환불 규정</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>code</td><td>String</td><td>code</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>nonRefundable</td><td>boolean</td><td>환불 불가</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>refundRates</td><td>ArrayList</td><td>일자별 취소 환불 규정 </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>offset</td><td>int</td><td>오프셋</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>offsetTimeUnit</td><td>TimeUnit</td><td>오프셋 시간 유닛</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>refundRate</td><td>double</td><td>환불율 </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>기술</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraGuestPolicy</td><td>Object</td><td>인원 추가 비용</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surchargeAvailable</td><td>boolean</td><td>인원 추가 요금 발생 여부</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surcharges</td><td>ArrayList</td><td>인원 추가 요금 설정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>ageType</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ADULT</td><td>성인</td></tr>
                                    <tr><td>CHILD</td><td>아동</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>minAge</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 12세 까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>surcharge</td><td>double</td><td>조식 요금 입력 ('현장결제' 기준으로 요금을 설정해주세요.)</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>description</td></tr>*/}

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraBedPolicy</td><td>Object</td><td>침구 추가 요금 설정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraBedAvailable</td><td>boolean</td><td>침구 추가 가능 여부</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surchargeAvailable</td><td>boolean</td><td>침구 추가 요금 발생 여부</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraBeds</td><td>ArrayList</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>name</td><td>String</td><td>침구 종류</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>extraBedType</td><td>Object</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>surcharges</td><td>ArrayList</td><td>surcharges</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>ageType</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ADULT</td><td>성인</td></tr>
                                    <tr><td>CHILD</td><td>아동</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>minAge</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 12세 까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level6}>surcharge</td><td>double</td><td>조식 요금 입력 ('현장결제' 기준으로 요금을 설정해주세요.)</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>description</td><td>String</td><td>description</td></tr>*/}

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkInOutPolicy</td><td>Object</td><td>체크인/체크아웃 시간</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>wholeDay</td><td>Boolean</td><td>wholeDay</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>checkInStartTime</td><td>String</td><td>체크인 시간 (HH:mm)</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>checkInEndTime</td><td>String</td><td>checkInEndTime</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>checkOutEndTime</td><td>String</td><td>체크아웃 시간 (HH:mm)</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>minAge</td><td>Integer</td><td>minAge</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>instructions</td><td>ArrayList</td><td>안내</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>freeServicePolicy</td><td>Object</td><td>체크인/체크아웃 안내 사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>freeServices</td><td>ArrayList</td><td>	무료 서비스 제공 유형</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>freeServiceType</td><td>String</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>FREE_DRINK</td><td>무료 음료</td></tr>
                                <tr><td>FREE_GIFT</td><td>무료 선물</td></tr>
                                <tr><td>FREE_ROOM_UPGRADE</td><td>객실 무료 업그레이드</td></tr>
                                <tr><td>FREE_VIEW_UPGRADE</td><td>객실 뷰 무료 업그레이드</td></tr>
                                <tr><td>ETC</td><td>기타</td></tr>
                                </tbody>
                            </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>name</td><td>String</td><td>무료 서비스명</td></tr>
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>description</td><td>String</td><td>description</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>기술</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraPackagePolicy</td><td>Object</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraPackages</td><td>ArrayList</td><td>extraPackages</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>name</td><td>String</td><td>name</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>extraPackageType</td><td>ArrayList</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>ENTRANCE_TICKET</td><td>입장권</td></tr>
                                <tr><td>ETC</td><td>기타</td></tr>
                                </tbody>
                            </table></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>설명</td></tr>

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>dayUsePolicy</td><td>DayUsePolicy</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>dayUse</td><td>boolean</td><td>dayUse</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>startTime</td><td>LocalTime</td><td>startTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>endTime</td><td>LocalTime</td><td>endTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>description</td><td>String</td><td>description</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraPricePolicy</td><td>ExtraPricePolicy</td><td></td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraPriceExist</td><td>boolean</td><td>extraPriceExist</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraPrices </td><td> Map{'<FacilityType,ExtraPrice> '}</td><td>extraPrices</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>List{'<TravelDescription>'}</td><td>description</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>title</td><td>String</td><td>title</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>type</td><td>String</td><td>type</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>content</td><td>String</td><td>content</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>format</td><td>ContentFormat</td>*/}
                        {/*    <td> <table className="table table-striped">*/}
                        {/*        <tbody>*/}
                        {/*        <tr><th>Optional Value</th><th>Description</th></tr>*/}
                        {/*        <tr><td>TEXT</td><td>TEXT</td></tr>*/}
                        {/*        <tr><td>HTML</td><td>HTML</td></tr>*/}
                        {/*        <tr><td>JSON</td><td>JSON</td></tr>*/}
                        {/*        <tr><td>IMAGE</td><td>IMAGE</td></tr>*/}
                        {/*        <tr><td>URL</td><td>URL</td></tr>*/}
                        {/*        </tbody>*/}
                        {/*    </table></td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>String> extension</td><td>Map{'<String,String>'} </td><td>extension</td></tr>*/}
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>deleted</td><td>boolean</td><td>삭제됨</td></tr>

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>checkInOutPolicy</td><td>CheckInOutPolicy</td><td>checkInOutPolicy</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>wholeDay</td><td>Boolean</td><td>wholeDay</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkInStartTime</td><td>String</td><td>checkInStartTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkInEndTime</td><td>String</td><td>checkInEndTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkOutEndTime</td><td>String</td><td>checkOutEndTime</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>minAge</td><td>Integer</td><td>minAge</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>instructions</td><td>List{'<TravelDescription>'} </td><td>instructions</td></tr>*/}

                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>spokenLanguages</td><td>List{'<String>'}</td><td>spokenLanguages</td></tr>*/}
                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>extension</td><td>Map{'<String,String>'} </td><td>extension information</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>errors</td><td>ArrayList</td><td>오류</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>deleted</td><td>Boolean</td><td>삭제됨</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>nation</td><td>String</td><td>국가</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>localName</td><td>String</td><td>로컬명</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>localAddress</td><td>Object</td><td>현지 주소</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>createdAt</td><td>LocalDateTime</td><td>생성 일자</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>modifiedAt</td><td>LocalDateTime</td><td>수정 일자</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>createdBy</td><td>String</td><td>생성자</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>modifiedBy</td><td>String</td><td>수정자</td></tr>


                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "SUCCESS",
    "data": {
        "createdAt": "2020-04-29T23:44:16.216",
        "modifiedAt": "2020-04-30T00:29:54.704",
        "createdBy": "SYSTEM",
        "modifiedBy": "SYSTEM",
        "travelProductId": 572809504203210754,
        "sellerProductId": "seller product 1",
        "vendorId": "A001000111",
        "productId": 100000000051860,
        "sellerCategoryId": null,
        "sellerCategoryName": null,
        "productDetailType": "HOTEL",
        "vendorItemPackageId": 300000000051806,
        "travelType": "OVERSEAS",
        "qcStatus": "COMPLETE_APPROVAL",
        "saleStatus": "ON_SALE",
        "name": "하이 인",
        "introduction": "product introduction - 2",
        "notice": "product notice - 2",
        "benefits": [
            "benefit 3",
            "benefit 4"
        ],
        "displayCategoryCode": 105393,
        "displayKeyword": "Shanghai",
        "searchTags": [
            "shanghai",
            "disney"
        ],
        "images": [
            {
                "path": "travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg",
                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",
                "sellerUrlMethod": "GET",
                "representative": true,
                "sellerImageCategory": null,
                "imageGroup": "VIEW",
                "resizedImages": [
                    {
                        "type": "RESIZE_1180_630_60",
                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg"
                    }
                ],
                "description": null,
                "seq": 0
            },
            {
                "path": "travelConnect/hotel/A00100622/1b955960-8ca3-498c-abde-40a2b03d2841.jpg",
                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": null,
                "imageGroup": "ROOM",
                "resizedImages": [
                    {
                        "type": "RESIZE_1180_630_60",
                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b955960-8ca3-498c-abde-40a2b03d2841.jpg"
                    }
                ],
                "description": null,
                "seq": 0
            },
            {
                "path": "travelConnect/hotel/A00100622/b239efbe-fdf0-4dd3-bbc4-e48413f4a36f.jpg",
                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": null,
                "imageGroup": "VIEW",
                "resizedImages": [
                    {
                        "type": "RESIZE_1180_630_60",
                        "path": "resized_image/"
                    }
                ],
                "description": null,
                "seq": 0
            },
            {
                "path": "travelConnect/hotel/A00100622/02e3c266-abb5-40bf-af5b-c4943d5b12a1.jpg",
                "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": null,
                "imageGroup": "VIEW",
                "resizedImages": [
                    {
                        "type": "RESIZE_1180_630_60",
                        "path": "resized_image/"
                    }
                ],
                "description": null,
                "seq": 0
            },
            {
                "path": "travelConnect/hotel/A00100622/8a01c3ba-b054-4e19-8d5c-1e6756cb444e.jpg",
                "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",
                "sellerUrlMethod": "GET",
                "representative": false,
                "sellerImageCategory": null,
                "imageGroup": "ROOM",
                "resizedImages": [
                    {
                        "type": "RESIZE_1180_630_60",
                        "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/8a01c3ba-b054-4e19-8d5c-1e6756cb444e.jpg"
                    }
                ],
                "description": null,
                "seq": 0
            }
        ],
        "sellerPropertyCategory": null,
        "areaId": null,
        "sellerBrandId": null,
        "brandCode": null,
        "brandName": null,
        "sellerChainId": null,
        "chainCode": null,
        "chainName": null,
        "airportCode": null,
        "cityCode": null,
        "registryNumber": null,
        "multiUnit": null,
        "buildDate": null,
        "renovationDate": null,
        "propertyCode": null,
        "ttiCode": null,
        "childrenAllowed": null,
        "petsAllowed": null,
        "breakfastServed": null,
        "sellerTaxId": null,
        "allRatePlanInclusive": null,
        "someRatePlanInclusive": null,
        "allInclusiveDetail": null,
        "minLOS": 0,
        "maxLOS": 0,
        "roomQuantity": 0,
        "totalFloors": 0,
        "rating": null,
        "refundByBusinessDay": true,
        "cancelType": "AUTO",
        "cancelPeriodType": null,
        "cancelPolicyNotice": "cancel policy notice-2",
        "sellerInstanceBooking": null,
        "instantBooking": true,
        "additionalInfoPrompt": "changed: additional info prompt",
        "usageGuide": "usage guide - 2",
        "usageNotice": "usage notice - 2",
        "legalTerms": null,
        "descriptions": null,
        "locations": [
            {
                "latitude": 32.260077,
                "longitude": 122.448697,
                "roadNameAddress": "Shanghai 상하이 shanghaihutail617-2",
                "landNumberAddress": null,
                "nation": "CN",
                "province": "shanghai-2",
                "city": "shanghai-2",
                "district": null,
                "town": null,
                "zipCode": "200000-2"
            }
        ],
        "reservationNotifications": [
            {
                "type": "PHONE",
                "contactInfo": "010-2345-6789",
                "contactDescription": "reservation notification 1 - 2"
            }
        ],
        "contacts": [
            {
                "contactType": "WEBSITE",
                "contactUseType": "REPRESENTATIVE",
                "contact": "www.example.com"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "REPRESENTATIVE",
                "contact": "010-2345-6789"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "BOOKING_INQUIRY",
                "contact": "010-2345-6789"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "CANCEL_INQUIRY",
                "contact": "010-2345-6789"
            },
            {
                "contactType": "PHONE",
                "contactUseType": "EMERGENCY",
                "contact": "010-2345-6789"
            }
        ],
        "review": null,
        "trafficInfo": "traffic info - 2",
        "publicTransportInfo": "public transport infomation - 2",
        "nearbyLandmarks": [
            {
                "name": "nearbyLandmark 1",
                "latitude": 31,
                "longitude": 121,
                "distance": 1,
                "distanceUnit": "KILOMETER",
                "direction": null,
                "transportations": null
            },
            {
                "name": "nearbyLandmark 1",
                "latitude": 31.1,
                "longitude": 121.1,
                "distance": 500,
                "distanceUnit": "METER",
                "direction": null,
                "transportations": null
            }
        ],
        "amenities": [
            {
                "sellerAmenityId": null,
                "id": "ACCOMMODATION_LEISURE_43",
                "name": null,
                "value": null
            },
            {
                "sellerAmenityId": null,
                "id": "ACCOMMODATION_LEISURE_57",
                "name": null,
                "value": null
            },
            {
                "sellerAmenityId": null,
                "id": "ACCOMMODATION_COMFORT_37",
                "name": null,
                "value": null
            }
        ],
        "attributes": null,
        "themes": [
            {
                "sellerThemeId": null,
                "id": "ACCOMMODATION_THEME_65",
                "name": null
            }
        ],
        "statistics": null,
        "meetingRooms": null,
        "restaurants": null,
        "operationPeriods": null,
        "rooms": [
            {
                "travelItemId": 572809504203210753,
                "sellerItemId": "seller room 1",
                "name": "패밀리 타운홈",
                "roomType": null,
                "roomCategory": null,
                "saleStatus": null,
                "saleStartedAt": "2020-01-01T00:00:01",
                "saleEndedAt": "2099-12-31T23:59:59",
                "taxType": null,
                "totalCount": 30,
                "area": 22,
                "floor": null,
                "roomComponent": {
                    "componentsCount": {
                        "ROOM_COMPONENT_COUNT_106": 1,
                        "ROOM_COMPONENT_COUNT_105": 1
                    },
                    "bedsCount": {
                        "BED_TYPE_89": 1
                    }
                },
                "images": [
                    {
                        "path": "travelConnect/hotel/A00100622/d452ed5f-5766-4cdc-8794-584fded4f99e.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/01dc966d_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "ROOM",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/d452ed5f-5766-4cdc-8794-584fded4f99e.jpg"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    },
                    {
                        "path": "travelConnect/hotel/A00100622/1c3742cd-6a13-4a20-8d09-8d3ba4ca2fc3.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/15eb6d89_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "ROOM",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1c3742cd-6a13-4a20-8d09-8d3ba4ca2fc3.jpg"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    },
                    {
                        "path": "travelConnect/hotel/A00100622/2e216e53-502e-4742-ac62-7be4b5d463c7.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/43000000/42710000/42709900/42709843/b16aa16a_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "ROOM",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    }
                ],
                "descriptions": [
                    {
                        "title": null,
                        "type": null,
                        "content": "room additional information",
                        "format": "TEXT",
                        "path": null,
                        "sellerUrl": null,
                        "sellerUrlMethod": "GET",
                        "seq": 0
                    }
                ],
                "amenities": [
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_GENERAL_6",
                        "name": null,
                        "value": null
                    },
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_BATH_78",
                        "name": null,
                        "value": null
                    },
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_SERVICE_22",
                        "name": null,
                        "value": null
                    }
                ],
                "bedGroups": [
                    {
                        "sellerBedGroupId": null,
                        "description": null,
                        "configurations": [
                            {
                                "size": null,
                                "type": "BED_TYPE_131",
                                "quantity": null
                            }
                        ],
                        "priceCheck": null
                    }
                ],
                "occupancy": {
                    "standardOccupancy": 2,
                    "totalMaxAllowed": 4,
                    "adultMaxAllowed": null,
                    "childMaxAllowed": 1,
                    "ageCategories": []
                },
                "views": [
                    {
                        "sellerViewId": null,
                        "id": "ROOM_VIEW_115",
                        "name": null
                    }
                ],
                "extension": {},
                "deleted": false
            },
            {
                "travelItemId": 572811199108874240,
                "sellerItemId": "seller room 2 - update room",
                "name": "패밀리 타운홈",
                "roomType": null,
                "roomCategory": null,
                "saleStatus": null,
                "saleStartedAt": "2020-02-01T00:00:01",
                "saleEndedAt": "2098-12-31T23:59:59",
                "taxType": null,
                "totalCount": 10,
                "area": 30,
                "floor": null,
                "roomComponent": {
                    "componentsCount": {
                        "ROOM_COMPONENT_COUNT_109": 1
                    },
                    "bedsCount": {
                        "ROOM_COMPONENT_COUNT_108": 1
                    }
                },
                "images": [
                    {
                        "path": "travelConnect/hotel/A00100622/02e3c266-abb5-40bf-af5b-c4943d5b12a1.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "ROOM",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    },
                    {
                        "path": "travelConnect/hotel/A00100622/b239efbe-fdf0-4dd3-bbc4-e48413f4a36f.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "ROOM",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    },
                    {
                        "path": "travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg",
                        "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",
                        "sellerUrlMethod": "GET",
                        "representative": true,
                        "sellerImageCategory": null,
                        "imageGroup": "VIEW",
                        "resizedImages": [
                            {
                                "type": "RESIZE_1180_630_60",
                                "path": "resized_image/thumbnails/remote/1180x2360q60crop1180x630/image/travelConnect/hotel/A00100622/1b197184-e64e-416f-808d-470728087a98.jpg"
                            }
                        ],
                        "description": null,
                        "seq": 0
                    }
                ],
                "descriptions": [
                    {
                        "title": null,
                        "type": null,
                        "content": "add room - room additional information",
                        "format": "TEXT",
                        "path": null,
                        "sellerUrl": null,
                        "sellerUrlMethod": "GET",
                        "seq": 0
                    }
                ],
                "amenities": [
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_GENERAL_14",
                        "name": null,
                        "value": null
                    },
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_BATH_85",
                        "name": null,
                        "value": null
                    },
                    {
                        "sellerAmenityId": null,
                        "id": "ROOM_AMENITY_SERVICE_24",
                        "name": null,
                        "value": null
                    }
                ],
                "bedGroups": [
                    {
                        "sellerBedGroupId": null,
                        "description": null,
                        "configurations": [
                            {
                                "size": null,
                                "type": "BED_TYPE_131",
                                "quantity": null
                            }
                        ],
                        "priceCheck": null
                    }
                ],
                "occupancy": {
                    "standardOccupancy": 2,
                    "totalMaxAllowed": 4,
                    "adultMaxAllowed": null,
                    "childMaxAllowed": 2,
                    "ageCategories": null
                },
                "views": [
                    {
                        "sellerViewId": null,
                        "id": "string",
                        "name": null
                    }
                ],
                "extension": null,
                "deleted": false
            }
        ],
        "rates": [
            {
                "rateId": 572809504203210752,
                "travelItemIds": [
                    572809504203210753
                ],
                "sellerRateId": "seller rate 1",
                "name": "With Breakfast",
                "saleStartedAt": "2020-01-01T00:00:01",
                "saleEndedAt": "2099-12-31T23:59:59",
                "useSellerProvidedPrice": false,
                "useSellerProvidedFee": false,
                "valid": false,
                "rateType": null,
                "amenities": [],
                "bedGroups": [],
                "mealPolicy": {
                    "meals": [
                        {
                            "mealType": "BREAKFAST",
                            "included": true,
                            "numberOfGuests": 2,
                            "surchargeAvailable": true,
                            "sameRoomStandardOccupancy": false,
                            "mealStyle": "Chinese",
                            "surcharges": [
                                {
                                    "name": null,
                                    "ageType": "CHILD",
                                    "minAge": 9,
                                    "surcharge": 10000
                                }
                            ]
                        }
                    ],
                    "description": "meal policy notice"
                },
                "cancelPolicy": {
                    "code": null,
                    "nonRefundable": false,
                    "refundRates": [
                        {
                            "offset": 5,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 90
                        },
                        {
                            "offset": 4,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 80
                        },
                        {
                            "offset": 3,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 50
                        }
                    ],
                    "description": "cancel policy notice"
                },
                "extraGuestPolicy": {
                    "surchargeAvailable": true,
                    "surcharges": [
                        {
                            "name": null,
                            "ageType": "ADULT",
                            "minAge": 18,
                            "surcharge": 50000
                        }
                    ],
                    "description": null
                },
                "extraBedPolicy": {
                    "extraBedAvailable": true,
                    "surchargeAvailable": true,
                    "extraBeds": [
                        {
                            "name": "extra bed 1",
                            "extraBedType": "ADULT",
                            "surcharges": [
                                {
                                    "name": null,
                                    "ageType": "ADULT",
                                    "minAge": 18,
                                    "surcharge": 80000
                                }
                            ],
                            "description": null
                        }
                    ]
                },
                "checkInOutPolicy": {
                    "wholeDay": false,
                    "checkInStartTime": "15:00",
                    "checkInEndTime": null,
                    "checkOutEndTime": "11:00",
                    "minAge": null,
                    "instructions": [
                        {
                            "title": null,
                            "type": "instructions",
                            "content": "check in/out instruction",
                            "format": "TEXT",
                            "path": null,
                            "sellerUrl": null,
                            "sellerUrlMethod": "GET",
                            "seq": 0
                        }
                    ]
                },
                "freeServicePolicy": {
                    "freeServices": [
                        {
                            "freeServiceType": "FREE_DRINK",
                            "name": "Welcome drink",
                            "description": null
                        }
                    ],
                    "description": "free service policy notice"
                },
                "extraPackagePolicy": {
                    "extraPackages": [
                        {
                            "name": "Disney land",
                            "extraPackageType": "ENTRANCE_TICKET"
                        }
                    ],
                    "description": "extra package notice"
                },
                "dayUsePolicy": null,
                "extraPricePolicy": null,
                "description": [],
                "extension": {},
                "deleted": false
            },
            {
                "rateId": 572816506971226112,
                "travelItemIds": [
                    572811199108874240
                ],
                "sellerRateId": "seller rate 2",
                "name": "With Breakfast - Korean",
                "saleStartedAt": "2020-01-01T00:00:01",
                "saleEndedAt": "2099-12-31T23:59:59",
                "useSellerProvidedPrice": false,
                "useSellerProvidedFee": false,
                "valid": false,
                "rateType": null,
                "amenities": null,
                "bedGroups": null,
                "mealPolicy": {
                    "meals": [
                        {
                            "mealType": "BREAKFAST",
                            "included": true,
                            "numberOfGuests": 1,
                            "surchargeAvailable": true,
                            "sameRoomStandardOccupancy": false,
                            "mealStyle": "Korean",
                            "surcharges": [
                                {
                                    "name": null,
                                    "ageType": "CHILD",
                                    "minAge": 9,
                                    "surcharge": 12000
                                }
                            ]
                        }
                    ],
                    "description": "meal policy notice - 3"
                },
                "cancelPolicy": {
                    "code": null,
                    "nonRefundable": false,
                    "refundRates": [
                        {
                            "offset": 6,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 80
                        },
                        {
                            "offset": 5,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 60
                        },
                        {
                            "offset": 3,
                            "offsetTimeUnit": "DAYS",
                            "refundRate": 40
                        }
                    ],
                    "description": "cancel policy notice - 3"
                },
                "extraGuestPolicy": {
                    "surchargeAvailable": false,
                    "surcharges": [],
                    "description": null
                },
                "extraBedPolicy": {
                    "extraBedAvailable": false,
                    "surchargeAvailable": false,
                    "extraBeds": []
                },
                "checkInOutPolicy": {
                    "wholeDay": false,
                    "checkInStartTime": "15:00",
                    "checkInEndTime": null,
                    "checkOutEndTime": "11:00",
                    "minAge": null,
                    "instructions": [
                        {
                            "title": null,
                            "type": "instructions",
                            "content": "check in/out instruction - 3",
                            "format": "TEXT",
                            "path": null,
                            "sellerUrl": null,
                            "sellerUrlMethod": "GET",
                            "seq": 0
                        }
                    ]
                },
                "freeServicePolicy": {
                    "freeServices": [
                        {
                            "freeServiceType": "FREE_DRINK",
                            "name": "Welcome drink",
                            "description": null
                        }
                    ],
                    "description": "free service policy notice"
                },
                "extraPackagePolicy": {
                    "extraPackages": [
                        {
                            "name": "Disney land",
                            "extraPackageType": "ENTRANCE_TICKET"
                        }
                    ],
                    "description": "extra package notice"
                },
                "dayUsePolicy": null,
                "extraPricePolicy": null,
                "description": null,
                "extension": null,
                "deleted": true
            }
        ],
        "checkInOutPolicy": null,
        "spokenLanguages": null,
        "extension": null,
        "errors": null,
        "deleted": false,
        "nation": "CN",
        "localName": "假日酒店",
        "localAddress": null
    }
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/LodgingAPIContent/LodgingProductAPI/GetLodgingProductInfo.jsx